import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import Fa from 'react-fontawesome';
import { requestUpdateOrganizationUser } from '../../SetupActions';

class ToggleRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updating: false,
    };
    this.onToggle = this.onToggle.bind(this);
  }
  
  onToggle() {
    if (this.state.updating) {
      return;
    }
    const { value, data, organization } = this.props;
    if (!data || !organization) {
      return;
    }
    this.setState({ updating: true }, () => {
      const userId = data._id;
      const params = { disable_feedback_request: !value };
      const p1 = this.props.dispatch(requestUpdateOrganizationUser(organization._id, userId, params));
      const p2 = new Promise((resolve) => {
        delay(() => {
          resolve();
        }, 1000);
      });
      Promise.all([p1, p2])
        .then(
          ([result]) => {
            this.setState({ updating: false });
            this.props.onUpdate(result.user);
          },
          () => {

          },
        );
    });
  }

  render() {
    const { value, data } = this.props;
    if (!data) {
      return null;
    }
    if (data.is_none_standard_user) {
      return (<div className="text-center text-muted"><em>Non CRM User</em></div>);
    }

    if (data.active !== true) {
      return (<div className="text-center text-muted"><em>Inactive</em></div>);
    }


    const realValue = value === true;
    const { updating } = this.state;
    const disabled = updating;
    let cls = '';
    let name = 'square-o';
    if (realValue === true) {
      cls = 'text-danger';
      name = 'check-square-o';
    }
    if (disabled) {
      cls = 'text-muted';
      name = 'spinner';
    }
    return (
      <div style={{ cursor: (disabled ? 'not-allowed' : 'pointer') }} className="text-center" onClick={this.onToggle}>
        <Fa className={cls} style={{ fontSize: '1.3em' }} name={name} spin={disabled} />
      </div>
    );
  }
}

ToggleRenderer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    is_none_standard_user: PropTypes.bool,
    active: PropTypes.bool,
  }),
  value: PropTypes.bool,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
};
ToggleRenderer.defaultProps = {
  data: null,
  value: false,
  organization: null,
  onUpdate: () => {},
};

function mapStateToProps() {
  return {
  };
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(ToggleRenderer);
